/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { AppPhase } from '../../models/communication/app-enums.model';
import { TableUpdate } from '../../models/communication/app-state.model';
import { CardValue } from '../../models/communication/cards.enum';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';
import { ThreeHeadedDragonCardPosition } from '../game-types/three-headed-dragon/three-headed-dragon.model';
import { CardState } from '../models/game-view.model';

export class ThreeHeadedDragonFlow extends GameFlowBase<GameBase> {
    override update(tableUpdate?: TableUpdate, appPhase?: AppPhase): void {
        if (appPhase === AppPhase.Decision) {
            this.game.showPlayerDecisionTime();
            return;
        }

        if (!this.game.isUpdateDataValid(tableUpdate)) {
            return;
        }

        if ('cardPosition' in tableUpdate) {
            if (tableUpdate.card !== CardValue.Unknown) {
                this.game.revealCard(tableUpdate.cardPosition!, tableUpdate.card!);
            } else if (tableUpdate.cardPosition === ThreeHeadedDragonCardPosition.TigerCard) {
                this.game.updateCard(tableUpdate.cardPosition, CardState.Checked);
                this.game.showAllCardsDrawn();
            }
        }

        if ('nextCardPosition' in tableUpdate) {
            if (tableUpdate.nextCardPosition === ThreeHeadedDragonCardPosition.TigerCard) {
                this.game.showFaceDownMessage(tableUpdate.nextCardPosition);
            } else {
                this.game.showFaceUpMessage(tableUpdate.nextCardPosition!);
            }
        }

        if ('outcome' in tableUpdate) {
            this.game.handleOutcome(tableUpdate);
        }
    }
}
